import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import {
  BookImage,
  Bot,
  Captions,
  Facebook,
  Image,
  ImageMinus,
  ImagePlay,
  ImageUpscale,
  Mail,
  MessageSquare,
  Podcast,
  Rocket,
  Rss,
  Search,
  Speaker,
  Sticker,
} from 'lucide-react';

interface SearchBarProps {
  placeholder: string;
}

const applications = [
  {
    name: 'Blog Writer',
    link: '/ai-blog-writer/get-started',
    icon: <Rss />,
  },
  {
    name: 'Email Generator',
    link: '/email-generator/get-started',
    icon: <Mail />,
  },
  {
    name: 'Chat With Docs',
    link: '/chat-with-docs/get-started',
    icon: <MessageSquare />,
  },
  {
    name: 'Text to Image',
    link: '/text-to-image/get-started',
    icon: <Image />,
  },
  {
    name: 'Text to Logo',
    link: '/text-to-logo/get-started',
    icon: <Rocket />,
  },
  {
    name: 'Sticker Maker',
    link: '/sticker-maker/get-started',
    icon: <Sticker />,
  },
  {
    name: 'Gif Maker',
    link: '/gif-maker/get-started',
    icon: <ImagePlay />,
  },
  {
    name: 'Transcript Generator',
    link: '/transcript',
    icon: <Captions />,
  },
  {
    name: 'Text to Speech',
    link: '/text-to-speech/get-started',
    icon: <Speaker />,
  },
  {
    name: 'Podcast',
    link: '/ai-podcast-generator/get-started',
    icon: <Podcast />,
  },
  {
    name: 'Social Media',
    link: '/social-media/get-started',
    icon: <Facebook />,
  },
  {
    name: 'Bot Builder',
    link: '/bot-builder/get-started',
    icon: <Bot />,
  },
  {
    name: 'Brand Book',
    link: '/brandbook/get-started',
    icon: <BookImage />,
  },
  {
    name: 'Upscale Image',
    link: '/upscale-image/get-started',
    icon: <ImageUpscale />,
  },
  {
    name: 'Object Remover',
    link: '/object-remover/get-started',
    icon: <ImageMinus />,
  },
];

const SearchBar: React.FC<SearchBarProps> = ({ placeholder }) => {
  const [search, setSearch] = useState('');
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);

  // Mock data for dropdown - replace with actual data source

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearch(value);
    setShowDropdown(value.length > 0);
  };

  return (
    <div className="relative flex-1 flex items-center max-w-[304px] bg-background-main px-1 rounded-md">
      <Search className="text-primary w-4 h-4 ml-2" />
      <div className="px-2 py-1 w-full">
        <input
          type="text"
          placeholder={placeholder}
          value={search}
          onChange={handleInputChange}
          onFocus={() => setShowDropdown(true)}
          onBlur={() =>
            !search && setTimeout(() => setShowDropdown(false), 200)
          }
          className="w-full h-[22px] border-none bg-background-main text-primary focus:outline-none placeholder-text-placeholder focus:ring-0"
        />
        {showDropdown && (
          <div className="absolute left-0 right-0 top-full mt-1 text-primary  bg-background-main border rounded-md shadow-lg z-50">
            {applications
              .filter((item) =>
                item.name.toLowerCase().includes(search.toLowerCase())
              )
              .map((application, index) => (
                <div
                  key={index}
                  className="px-4 py-2 flex items-center gap-2 hover:bg-icons-hover cursor-pointer [&_svg]:h-4 [&_svg]:w-4"
                  onClick={() => {
                    setSearch(application.name);
                    setShowDropdown(false);
                    navigate(application.link);
                  }}
                >
                  {application.icon}
                  {application.name}
                </div>
              ))}
            {search &&
              applications.filter((item) =>
                item.name.toLowerCase().includes(search.toLowerCase())
              ).length === 0 && (
                <div className="px-4 py-2 flex items-center gap-2 hover:bg-gray-100 cursor-pointer [&_svg]:h-4 [&_svg]:w-4">
                  No results for {search}
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
